import {
  Breadcrumb,
  Button,
  message,
  PageHeader,
  Popconfirm,
  Table,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { equipmentTypeService, workItemService } from "_services";
import Search from "./Search";
import { Auth } from "_helpers";

const List = ({ match }) => {
  const { path } = match;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    getItems(pageNumber, pageSize);
  }, []);

  const getItems = (pageNumber, pageSize) => {
    

    setLoading(true);
    workItemService
      .search(`${searchParams}`)
      .then((data) => {
        setItems(data.content);
        setLoading(false);
        setTotalRecords(data.pagination.totalRecords);
        setPageNumber(pageNumber);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSearchResults = (results, totalRecords, searchParams) => {
    setItems(results);
    setTotalRecords(totalRecords);
    setSearchParams(searchParams);
    setPageNumber(1);
    setLoading(false);
  };

  const handlePaginateChange = (pageNumber, pageSize) => {
    getItems(pageNumber, pageSize);
  };

  const handleDelete = (id) => {
    workItemService
      .delete(id)
      .then((x) => {
        message.success("Successfully deleted!");
        getItems(pageNumber, pageSize);
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Link to={`${path}/add`} key="1">
          <Button>Add</Button>
        </Link>
      );
    }
    return buttons;
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      render: (text, record) => (
        <Link to={`/work-items/${record.id}/summary`}>{text ? text : "_"}</Link>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Job Tasks",
      key: "jobTasks",
      render: (text, record) => (
        <span>
          {record.jobTasks && record.jobTasks.length > 0
            ? record.jobTasks.map((task) => task.name).join(", ")
            : "No tasks"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"]) && (
            <Popconfirm
              title="Are you sure to delete this item?"
              onConfirm={() => handleDelete(record.id)}
            >
              <CloseOutlined />
            </Popconfirm>
          )
        );
      },
    },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/work-items">Work Item Search</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <Search
            showSearchLoading={setLoading}
            onSearchResults={handleSearchResults}
          />
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            columns={columns}
            dataSource={items}
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: false,
              onChange: handlePaginateChange,
            }}
          />
        </Page>
      </PageHeader>
    </div>
  );
};

export default List;
